(function() { window.GUID_0094c960_04eb_43af_b913_7b8134342c6c = { getGuid: function() { return "0094c960-04eb-43af-b913-7b8134342c6c"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StripeCreditCard extends Controls.CreditCard {
            loadScript() {
                let me = this;
                if (typeof (Stripe) != "undefined") {
                    loadStripe(me);
                }
                else {
                    $.getScript("https://js.stripe.com/v3/", () => {
                        loadStripe(me);
                    });
                }
                function loadStripe(me) {
                    // Custom styling can be passed to options when creating an Element.
                    const style = {
                        base: {
                            //iconColor: '#666EE8',
                            //color: '#31325F',
                            '::placeholder': {
                            //  color: '#CFD7E0',
                            },
                        },
                    };
                    me.stripe = Stripe(me.publicKey);
                    me.elements = me.stripe.elements({ locale: me.locale });
                    me.cardNumberElement = me.elements.create('cardNumber', {
                    //style: style
                    });
                    me.cardNumberElement.mount('#' + me.ControlId + '-card-number-element');
                    me.cardExpiryElement = me.elements.create('cardExpiry', {
                    //style: style
                    });
                    me.cardExpiryElement.mount('#' + me.ControlId + '-card-expiry-element');
                    me.cardCvcElement = me.elements.create('cardCvc', {
                    //style: style
                    });
                    me.cardCvcElement.mount('#' + me.ControlId + '-card-cvc-element');
                    me.postalCodeElement = me.elements.create('postalCode', {
                    //style: style
                    });
                    me.postalCodeElement.mount('#' + me.ControlId + '-card-postalcode-element');
                    me.cardNumberElement.on('change', function (event) {
                        if (event.brand) {
                            me.setBrandIcon(event.brand);
                        }
                    });
                    // Create the payment request.
                    me.paymentRequest = me.stripe.paymentRequest({
                        country: 'US',
                        currency: 'usd',
                        total: {
                            label: 'Payment',
                            amount: 0,
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                        requestShipping: false,
                    });
                    // Callback when a payment method is created.
                    me.paymentRequest.on('token', event => {
                        me.$Control.triggerHandler('token', event);
                    });
                    // Create the Payment Request Button.
                    const paymentRequestButton = me.elements.create('paymentRequestButton', {
                        paymentRequest: me.paymentRequest
                    });
                    // Callback when a payment request button is clicked.
                    paymentRequestButton.on('click', event => {
                        let options = {
                            currency: 'usd',
                            total: {
                                label: '',
                                amount: 0
                            }
                        };
                        if (me.$Control.triggerHandler("paymentRequest", [options]) == false) {
                            event.preventDefault();
                        }
                        me.paymentRequest.update(options);
                    });
                    // Check if the Payment Request is available (or Apple Pay on the Web).
                    me.paymentRequest.canMakePayment().then((paymentRequestSupport) => {
                        let placeHolder = document.getElementById(me.ControlId + '-payment-request');
                        if (placeHolder) {
                            if (paymentRequestSupport) {
                                // Display the Pay button by mounting the Element in the DOM.
                                paymentRequestButton.mount('#' + me.ControlId + '-payment-request-button');
                                // Show the payment request section.
                                placeHolder.hidden = false;
                            }
                            else {
                                placeHolder.hidden = true;
                            }
                        }
                    });
                }
            }
            OnDispose() {
                try {
                    this.cardNumberElement.destroy();
                    this.cardExpiryElement.destroy();
                    this.cardCvcElement.destroy();
                    this.postalCodeElement.destroy();
                }
                catch (e) {
                }
                super.OnDispose();
            }
            onMakePaymentNewCard(useNewCardCallback) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    let token = yield this.stripe.createToken(this.cardNumberElement);
                    let result = {
                        token: (_a = token.token) === null || _a === void 0 ? void 0 : _a.id,
                        error: (_b = token.error) === null || _b === void 0 ? void 0 : _b.message
                    };
                    useNewCardCallback(result);
                });
            }
        }
        Controls.StripeCreditCard = StripeCreditCard;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stripe.js.map
